'use client';

import { ShieldX } from 'lucide-react';
import * as React from 'react';

import { type LinkLike, NativeLink } from '../../lib/link';

export interface AccessDeniedScreenProps {
	/** Titolo. Default: "Accesso negato". */
	title?: React.ReactNode;
	/** Messaggio esplicativo. Default: messaggio generico sui permessi mancanti. */
	message?: React.ReactNode;
	/** Testo del link di ritorno. Default: "Torna alla Dashboard". */
	actionLabel?: React.ReactNode;
	/** URL del link di ritorno. Default: `/dashboard`. */
	actionHref?: string;
	/** Componente link da usare (default: link nativo `<a>`); passare il `Link` del router quando serve navigazione client-side. */
	linkComponent?: LinkLike;
}

/**
 * Schermata a tutta sezione mostrata quando l'utente non ha i permessi per una rotta o
 * un'azione (es. ruolo insufficiente, socio senza accesso a un'area amministrativa),
 * con un link di ritorno alla dashboard.
 */
const AccessDeniedScreen = ({
	title = 'Accesso negato',
	message = 'Non hai i permessi necessari per accedere a questa sezione.',
	actionLabel = 'Torna alla Dashboard',
	actionHref = '/dashboard',
	linkComponent: Link = NativeLink,
}: AccessDeniedScreenProps) => (
	<div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
		<ShieldX className="h-12 w-12 text-danger" />
		<div>
			<div className="text-lg font-bold text-text-primary">{title}</div>
			<div className="mt-1 text-sm text-text-muted">{message}</div>
		</div>
		<Link
			href={actionHref}
			className="rounded-lg border border-accent/30 bg-accent/10 px-4 py-2 text-xs font-semibold text-accent transition-colors hover:bg-accent/20"
		>
			{actionLabel}
		</Link>
	</div>
);
AccessDeniedScreen.displayName = 'AccessDeniedScreen';

export { AccessDeniedScreen };
